import { QueryPage } from '@@ting/services/api/query-hooks'

export const getNextPageParam = (lastPage: QueryPage<any>, pages: QueryPage<any>[]) => {
  const cursor = pages.reduce((sum, page) => sum + page.data.length, 0)
  return cursor < lastPage.total ? cursor : undefined
}
